import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Breadcumb from '~/components/Breadcrumb';
import images from '~/assets/images';
import { Link } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';
// import { detailCourseVideo } from '~/Store/Action/detailCourseActions';
import { Worker } from '@react-pdf-viewer/core';
// Import the main Viewer component
import { Viewer } from '@react-pdf-viewer/core';
// Import the styles
import '@react-pdf-viewer/core/lib/styles/index.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import { Document } from 'react-pdf';
// default layout plugin
// import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
// Import styles of default layout plugin
// import '@react-pdf-viewer/default-layout/lib/styles/index.css';
// import '@react-pdf-viewer/core/lib/styles/index.css';
import axios from 'axios';

import { detailBook, checkBuyBook } from '~/Store/Action/detailBookActions';
const DetailCourseware = () => {
    const [searchParams] = useSearchParams();
    const { id } = useParams();
    const dispatch = useDispatch();
    const [user, setUser] = useState(null);
    const [item, setItem] = useState({});

    const book_chapter = searchParams.get('book');
    console.log(book_chapter);

    const auth = useSelector((state) => state.auth);

    const data = useSelector((state) => state.detailBook?.data?.data);
    const check = useSelector((state) => state.detailBook?.check?.data);

    const [pdfUrl, setPDFUrl] = useState(null);

    useEffect(() => {
        if (item) {
            const itemFileUrl = item[0]?.file;
            console.log(itemFileUrl);
            // fetchPDF(itemFileUrl);
        }
    }, [item]);

    useEffect(() => {
        if (auth.user) {
            setUser(JSON.parse(auth.user));
            load();
            async function load() {
                await dispatch(checkBuyBook(id, auth.token));
            }
        }
        dispatch(detailBook(id));
    }, [auth, id]);

    useEffect(() => {
        if (data?.book_chapter.length > 0) {
            const d = data?.book_chapter.filter((item, index) => item.id == book_chapter);
            console.log(d);
            console.log(book_chapter);
            console.log(data);
            setItem(d);
        }
    }, [book_chapter, data]);
    return (
        <div className="container">
            <Breadcumb title="Xem sách" />

            <div className="row mt-3">
                <div className="card border-0" style={{ background: 'none' }}>
                    <div className="row">
                        <div className="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 col-xxl-8">
                            {check ? (
                                item[0]?.file && (
                                    <>
                                        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.6.172/build/pdf.worker.min.js">
                                            <div
                                                style={{
                                                    // boxShadow: ' 0 1px 2.94px 0.06px rgba(4, 26, 55, 0.16)',
                                                    background: '#F5F5F5',
                                                    // padding: '20px 25px',
                                                    borderRadius: '5px',
                                                }}
                                            >
                                                <Viewer fileUrl={item[0]?.file}></Viewer>
                                            </div>
                                        </Worker>
                                    </>
                                )
                            ) : (
                                <div className="alert alert-warning">Bạn cần mua sách này để xem</div>
                            )}
                        </div>
                        <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4">
                            <div className="card-body">
                                <div className="row ">
                                    <h3 style={{ paddingBottom: '20px' }}>Danh sách chương</h3>
                                    <div className="col-12">
                                        <ul>
                                            {data?.book_chapter?.map((item, index) => (
                                                <li className="d-flex bg-light border p-2 align-items-center mb-3">
                                                    <Link
                                                        style={{ display: 'flex', alignItems: 'center' }}
                                                        to={'/doc-sach/' + item?.book_id + '?book=' + item?.id}
                                                    >
                                                        <div className="p-1 me-2">
                                                            {item?.status == 0 ? (
                                                                <svg
                                                                    className="rounded-3"
                                                                    width="24"
                                                                    height="24"
                                                                    viewBox="0 0 24 24"
                                                                    fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <rect
                                                                        width="24"
                                                                        height="24"
                                                                        rx="5"
                                                                        fill="#777777"
                                                                    />
                                                                    <g clip-path="url(#clip0_1448_40069)">
                                                                        <path
                                                                            d="M11.4556 9.35556C11.5333 9.35556 11.5333 9.35556 11.4556 9.35556C11.5333 9.04444 11.6111 8.88889 11.6111 8.65556V8.5C11.6889 8.11111 11.6889 7.8 11.6111 7.72222C11.6111 7.72222 11.6111 7.72222 11.6111 7.64444L11.5333 7.56667C11.5333 7.56667 11.5333 7.64444 11.4556 7.64444C11.3 8.11111 11.3 8.65556 11.4556 9.35556ZM9.12222 14.7222C8.96667 14.8 8.81111 14.8778 8.73333 14.9556C8.18889 15.4222 7.8 15.9666 7.72222 16.2C8.18889 16.1222 8.65556 15.6556 9.12222 14.7222C9.2 14.7222 9.2 14.7222 9.12222 14.7222C9.2 14.7222 9.12222 14.7222 9.12222 14.7222ZM16.2778 13.5556C16.2 13.4778 15.8889 13.2444 14.8 13.2444C14.7222 13.2444 14.7222 13.2444 14.6444 13.2444C14.6444 13.2444 14.6444 13.2444 14.6444 13.3222C15.1889 13.5556 15.7333 13.7111 16.1222 13.7111C16.2 13.7111 16.2 13.7111 16.2778 13.7111H16.3556C16.3556 13.7111 16.3556 13.7111 16.3556 13.6333C16.3556 13.6333 16.2778 13.6333 16.2778 13.5556ZM17.4444 5H6.55556C5.7 5 5 5.7 5 6.55556V17.4444C5 18.3 5.7 19 6.55556 19H17.4444C18.3 19 19 18.3 19 17.4444V6.55556C19 5.7 18.3 5 17.4444 5ZM16.5889 14.1778C16.4333 14.2556 16.2 14.3333 15.8889 14.3333C15.2667 14.3333 14.3333 14.1778 13.5556 13.7889C12.2333 13.9444 11.2222 14.1 10.4444 14.4111C10.3667 14.4111 10.3667 14.4111 10.2889 14.4889C9.35556 16.1222 8.57778 16.9 7.95556 16.9C7.8 16.9 7.72222 16.9 7.64444 16.8222L7.25556 16.5889V16.5111C7.17778 16.3555 7.17778 16.2778 7.17778 16.1222C7.25556 15.7333 7.72222 15.0333 8.65556 14.4889C8.81111 14.4111 9.04444 14.2556 9.35556 14.1C9.58889 13.7111 9.82222 13.2444 10.1333 12.7C10.5222 11.9222 10.7556 11.1444 10.9889 10.4444C10.6778 9.51111 10.5222 8.96667 10.8333 7.87778C10.9111 7.56667 11.1444 7.25556 11.4556 7.25556H11.6111C11.7667 7.25556 11.9222 7.33333 12.0778 7.41111C12.6223 7.95556 12.3889 9.2 12.0778 10.2111C12.0778 10.2889 12.0778 10.2889 12.0778 10.2889C12.3889 11.1444 12.8556 11.8444 13.3222 12.3111C13.5556 12.4667 13.7111 12.6222 14.0222 12.7778C14.4111 12.7778 14.7222 12.7 15.0333 12.7C15.9667 12.7 16.5889 12.8556 16.8222 13.2444C16.9 13.4 16.9 13.5556 16.9 13.7111C16.8222 13.7889 16.7444 14.0222 16.5889 14.1778ZM11.5333 11.1444C11.3778 11.6889 11.0667 12.3111 10.7556 13.0111C10.6 13.3222 10.4444 13.5556 10.2889 13.8667H10.3667H10.4444C11.4556 13.4778 12.3889 13.2444 13.0111 13.1667C12.8555 13.0889 12.7778 13.0111 12.7 12.9333C12.3111 12.4667 11.8444 11.8444 11.5333 11.1444Z"
                                                                            fill="white"
                                                                        />
                                                                    </g>
                                                                    <defs>
                                                                        <clipPath id="clip0_1448_40069">
                                                                            <rect
                                                                                width="14"
                                                                                height="14"
                                                                                fill="white"
                                                                                transform="translate(5 5)"
                                                                            />
                                                                        </clipPath>
                                                                    </defs>
                                                                </svg>
                                                            ) : (
                                                                <svg
                                                                    className="rounded-3"
                                                                    width="24"
                                                                    height="24"
                                                                    viewBox="0 0 24 24"
                                                                    fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <rect
                                                                        width="24"
                                                                        height="24"
                                                                        rx="5"
                                                                        fill="#777777"
                                                                    />
                                                                    <path
                                                                        d="M15.7057 10.7631V9.11604C15.7057 7.05722 14.0586 5.41016 11.9998 5.41016C9.94095 5.41016 8.29389 7.05722 8.29389 9.11604V10.7631C7.59389 10.7631 7.05859 11.2984 7.05859 11.9984V17.3513C7.05859 18.0102 7.59389 18.5866 8.29389 18.5866H15.7057C16.4057 18.5866 16.9409 18.0102 16.9409 17.3513V11.9984C16.9409 11.2984 16.4057 10.7631 15.7057 10.7631ZM9.11742 9.11604C9.11742 7.51016 10.3939 6.23369 11.9998 6.23369C13.6057 6.23369 14.8821 7.51016 14.8821 9.11604V10.7631H9.11742V9.11604ZM12.4115 15.2102V16.116C12.4115 16.3631 12.2468 16.5278 11.9998 16.5278C11.7527 16.5278 11.588 16.3631 11.588 16.116V15.2102C11.0939 15.0455 10.7645 14.5925 10.7645 14.0572C10.7645 13.3572 11.2998 12.8219 11.9998 12.8219C12.6998 12.8219 13.2351 13.3572 13.2351 14.0572C13.2351 14.5925 12.9057 15.0455 12.4115 15.2102Z"
                                                                        fill="white"
                                                                    />
                                                                </svg>
                                                            )}
                                                        </div>
                                                        <div>
                                                            <span>{item?.title}</span>
                                                        </div>
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DetailCourseware;
